import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShoppingBagSide = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "shopping-bag-side_icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23 5.947A1.93 1.93 0 0 0 21.1 4h-1.849A.25.25 0 0 1 19 3.75V3a3 3 0 0 0-3-3h-3a3 3 0 0 0-3 3v.75a.25.25 0 0 1-.25.25h-2a.25.25 0 0 1-.25-.25V3a1 1 0 0 1 1-1 1 1 0 0 0 0-2 3 3 0 0 0-3 3v.75a.25.25 0 0 1-.25.25H3.5a2 2 0 0 0-2.066 1.859L0 22.053A2.014 2.014 0 0 0 2.072 24H22.1a1.94 1.94 0 0 0 1.9-2.01ZM12 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v.75a.25.25 0 0 1-.25.25h-4.5a.25.25 0 0 1-.25-.25ZM2.559 21.975a.5.5 0 0 1-.5-.547l1.4-14.974A.5.5 0 0 1 3.957 6h2.625a.5.5 0 0 1 .5.472l.833 14.994a.5.5 0 0 1-.5.528Z" })
});
export { SvgShoppingBagSide as ReactComponent };
